import {GetExamResults, GetExamResultsModel, GetExamResultsParams} from 'domain/usecases';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';

export class RemoteGetExamResults implements GetExamResults {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetExamResultsModel>,
	) {}

	async get({signal, ...params}: GetExamResultsParams): Promise<GetExamResultsModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
			signal,
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return [];
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
